import {
  IconAccessControl,
  IconDatabase,
  IconHome,
  IconAlertTriangle,
  type IconComponent
} from '@gat-ship/icons'

/** The sidebar tabs of the tenant-user detail modal. */
export const TENANT_USER_DETAIL_SECTIONS = [
  'general',
  'database-access',
  'access-roles',
  'danger-zone'
] as const

export type TenantUserDetailSection =
  (typeof TENANT_USER_DETAIL_SECTIONS)[number]

export interface TenantUserDetailSidebarItem {
  key: TenantUserDetailSection
  label: string
  icon: IconComponent
}

/**
 * Sidebar items for the tenant-user detail modal — mirrors the routed
 * sub-menu (`TenantUserLayout.vue` `selectMenuItems`): General, Database
 * Access, Access Roles, Danger Zone.
 */
export function getTenantUserDetailSidebarItems(): TenantUserDetailSidebarItem[] {
  return [
    { key: 'general', label: 'General', icon: IconHome },
    { key: 'database-access', label: 'Database Access', icon: IconDatabase },
    { key: 'access-roles', label: 'Access Roles', icon: IconAccessControl },
    { key: 'danger-zone', label: 'Danger Zone', icon: IconAlertTriangle }
  ]
}

/** Validate a raw query value into a known section, defaulting to `general`. */
export function toValidTenantUserSection(
  value: string | null
): TenantUserDetailSection {
  return TENANT_USER_DETAIL_SECTIONS.includes(value as TenantUserDetailSection)
    ? (value as TenantUserDetailSection)
    : 'general'
}
